import React, { useCallback, useState } from 'react';
import { SelectHeaderTable } from './components/SelectHeaderTable';
import { ContinueButton } from '../../components/ContinueButton';
import { useRsi } from '../../hooks/useRsi';
import type { RawData } from '../../types';
import { Typography } from '@beeline.com/bp-design-system';
import { ModalBody } from '../../components/ModalBody';

type SelectHeaderProps = {
  data: RawData[];
  onContinue: (headerValues: RawData, data: RawData[]) => Promise<void>;
  onBack?: () => void;
};

export const SelectHeaderStep = ({ data, onContinue, onBack }: SelectHeaderProps) => {
  const { translations } = useRsi();
  const [selectedRows, setSelectedRows] = useState<ReadonlySet<number>>(new Set([0]));
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = useCallback(async () => {
    const [selectedRowIndex] = selectedRows;
    // We consider data above header to be redundant
    const trimmedData = data.slice((selectedRowIndex as number) + 1);
    setIsLoading(true);
    await onContinue(data[selectedRowIndex as number] as RawData, trimmedData);
    setIsLoading(false);
  }, [onContinue, data, selectedRows]);

  return (
    <>
      {/* This div is necessary for the parent grid layout. */}
      <div>
        <Typography dataTest="title" variant="h2" pb={2}>
          {translations.selectHeaderStep.title}
        </Typography>
        <Typography pb={5}>{translations.selectHeaderStep.subTitle}</Typography>
      </div>
      <ModalBody constrainBox pb={0} height="100%">
        <SelectHeaderTable data={data} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
      </ModalBody>
      <ContinueButton
        onContinue={handleContinue}
        onBack={onBack}
        title={translations.selectHeaderStep.nextButtonTitle}
        backTitle={translations.selectHeaderStep.backButtonTitle}
        isLoading={isLoading}
        trackStepName="Select the header row"
      />
    </>
  );
};
